<div class="services-container">
  <div class="services-list">
    <div class="service-item" *ngFor="let service of displayedServices">
      <div class="service-content">
        <app-icon [title]="service.name + ' ' + '(' + service.count + ')'" [glyph]="service.icon" [size]="'22'" [color]="service.color"></app-icon>
        <span class="service-name" [title]="service.name">{{ service.name }}</span>
        <span class="service-count" *ngIf="service.count > 1">({{ service.count }})</span>
      </div>
    </div>

    <div class="service-item more-button" *ngIf="hasMore">
      <a class="link link--dotted" (click)="showAllServices()">еще</a>
    </div>
  </div>
</div>
